import React from 'react'
import { styled } from '@mui/system'
import type { FeedItem } from '../../../Api'
import { MAX_GRADIENT_WIDTH } from '../../consts'

type StyleProps = {
  image?: string
}

export const ArticleStyle = styled('a')<StyleProps>(({ image, theme }) => ({
  display: 'block',
  margin: theme.spacing(0, 7),
  [theme.breakpoints.between('sm', 'md')]: {
    margin: theme.spacing(0, 3),
  },
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(0),
  },
  '& .back': {
    borderRadius: 8,
    backgroundImage: image ? `url(${image})` : 'none',
    backgroundSize: '100% auto',
    backgroundRepeat: 'no-repeat',
    height: '43vw',
    padding: 0,
    color: '#fff',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
      height: '47vw',
    },
  },
  '& .gradient': {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '100%',
    maxWidth: MAX_GRADIENT_WIDTH,
    background: 'linear-gradient(90deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%)',
    borderRadius: 8,
  },
}))
export const TextCon = styled('div')<StyleProps>(({ image, theme }) => ({
  maxWidth: 540,
  position: 'absolute',
  padding: 34,
  bottom: 0,
  '& a': {
    color: '#fff',
    textDecoration: 'none',
  },
  [theme.breakpoints.down('md')]: {
    maxWidth: 420,
  },
  '& .head': {
    fontSize: 42,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    [theme.breakpoints.between('sm', 'md')]: {
      fontSize: 32,
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
  },
}))

type TrendingArticleProps = {
  feedItem: FeedItem
}

export const TrendingArticle: React.FC<
  React.PropsWithChildren<TrendingArticleProps>
> = ({ feedItem }) => {

  return (
    <ArticleStyle image={feedItem.previewImage} href={feedItem.shareLink} aria-label={feedItem.title || feedItem.shareLink}>
      <div className="back">
        <div className="gradient" />
        <TextCon>
          <div className="head">{feedItem.title}</div>
        </TextCon>
      </div>
    </ArticleStyle>
  )
}
